var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.65967 5C3.65967 3.89543 4.56349 3 5.67842 3H8.9884C9.42286 3 9.80858 3.27543 9.94597 3.68377L11.4578 8.17721C11.6167 8.64932 11.4009 9.16531 10.9517 9.38787L8.67324 10.5165C9.78581 12.9612 11.7738 14.9308 14.2414 16.033L15.3807 13.7757C15.6053 13.3306 16.1261 13.1169 16.6027 13.2743L21.1382 14.7721C21.5504 14.9082 21.8284 15.2903 21.8284 15.7208V19C21.8284 20.1046 20.9246 21 19.8097 21H18.8003C10.4384 21 3.65967 14.2843 3.65967 6V5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1fdb0e53bbe65bec498e73f94b81df8e.svg";
export { ForwardRef as ReactComponent };